import Model from './Model'
import FontDefinition from '../Fonts/FontDefinition'
import NameSeeder from '../Seeders/NameSeeder'
import RGBA from '../Fonts/RGBA'

let nameSeeder = new NameSeeder();

let horizontalPadding = 20;
let verticalPadding = 10;
let arrowSize = 5;
let radius = 7;

export default class ToolTipText extends Model
{

  constructor(width, height, data) {

    super(...arguments);

    this.fontName = 'arial';
    this.fontSize = 12;

    this.center.x = this.width / 2;
    this.timer = null;

  }

  setText(text) {
    if (this.text !== text) {
      this.text = text;
      this.needsRendering = true;
      this.cancelHide();
    }
  }

  clear(ctx, gameX, gameY, gameWidth, gameHeight) {

    if (this.needsRendering) {

      ctx.clearRect(gameX + this.previousX, gameY + this.previousY, this.scale(this.width + 1), this.scale(this.height + 1));

    }

  }

  scheduleHide() {
    this.cancelHide();
    this.timer = setTimeout(() => {
      this.hide();
    }, 10);
  }


  cancelHide() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  hide() {

    super.hide(...arguments);

    this.x = -1000;
    this.y = -1000;
    this.needsRendering = true;

  }

  draw(ctx) {

    let text = this.text;

    let textWidth = this.getTextWidth(ctx, text);

    this.setHeight(ctx, this.fontSize + verticalPadding * 2 + arrowSize);

    let x = ((this.width - textWidth) / 2) - horizontalPadding;

    this.ctx.canvas.width = this.ctx.canvas.width;

    ctx.beginPath();
    ctx.moveTo(this.scale(radius + x), this.scale(arrowSize));
    // top (left from arrow)
    ctx.lineTo(this.scale((this.width) / 2 - arrowSize), this.scale(arrowSize));
    // arrow left side
    ctx.lineTo(this.scale((this.width) / 2), this.scale(0));
    // arrow ride side
    ctx.lineTo(this.scale((this.width) / 2 + arrowSize), this.scale(arrowSize));
    // top (right from arrow)
    ctx.lineTo(this.scale(this.width - x - radius), this.scale(arrowSize));
    // top right corner
    ctx.quadraticCurveTo(this.scale(this.width - x), this.scale(arrowSize), this.scale(this.width - x), this.scale(arrowSize + radius));
    // right
    ctx.lineTo(this.scale(this.width - x), this.scale(this.height - radius));
    // bottom right corner
    ctx.quadraticCurveTo(this.scale(this.width - x), this.scale(this.height), this.scale(this.width - x - radius), this.scale(this.height));
    // bottom
    ctx.lineTo(this.scale(x + radius), this.scale(this.height));
    // bottom left corner
    ctx.quadraticCurveTo(this.scale(x), this.scale(this.height), this.scale(x), this.scale(this.height - radius));
    // left
    ctx.lineTo(this.scale(x), this.scale(arrowSize + radius));
    // top left corner
    ctx.quadraticCurveTo(this.scale(x), this.scale(arrowSize), this.scale(x + radius), this.scale(arrowSize));

    ctx.fillStyle = 'white';
    ctx.fill();




    ctx.fillStyle = 'black';
    ctx.font = new FontDefinition(this.fontName).size(this.scale(this.fontSize));
    ctx.fillText(text, this.scale((this.width - textWidth) / 2), this.scale(this.fontSize + verticalPadding + arrowSize));

  }

  getTextWidth(ctx, text) {

    ctx.font = new FontDefinition(this.fontName).size(this.fontSize);
    return ctx.measureText(text).width;

  }

  setWidth(ctx, width) {
    if (width === this.width) {
      return;
    }

    this.center.x = width / 2;

    this.width = width;
    this.ctx.canvas.width = this.scale(width);
    this.ctx.width = this.scale(width);

  }

  setHeight(ctx, height) {

    if (height === this.height) {
      return;
    }

    this.height = height;
    this.ctx.canvas.height = this.scale(height);
    this.ctx.height = this.scale(height);

  }
}
